<template src="./usersEditModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import usersEndpoints from '../users.endpoints.js';
import dualListView from '../../../components/dualListView.vue';
import Vue from 'vue';

export default {
    name: 'users-edit-modal',
    components: { dualListView: dualListView },
    mixins: [dmModalMixin],
    data() {
        return {
            dto: {
                EntityRoles: [
                    {
                        EntityID: null,
                        RoleID: null,
                    },
                ],
            },
            tabAnimation: {
                previous: {
                    effect: 'None',
                },
                next: {
                    effect: 'None',
                },
            },
            listViewFields: {
                text: 'EntityName',
                value: 'EntityID'
            },
            entitiesForUserType: [],
            entitiesFilterText: '',
            listviewDropdownTemplate: () => {
				return {
					template: Vue.component('dropdownTemplate', {
						template: `<div class="dm-flex-row dm-justify-content-space-between dm-align-items-center">
                                        <div>
                                            <ejs-checkbox class="dm-margin-right-sm" :checked="true"></ejs-checkbox>
                                            <span style="margin-left: 5px">{{data.EntityName}}</span>
                                        </div>
                                        <div class="app-input-md">
                                            <ejs-dropdownlist
                                                cssClass="role-dropdown"
                                                :dataSource="$store.state.roleOptions"
                                                :fields="roleFields"
                                                v-model="selectedEntity.RoleID">
                                            </ejs-dropdownlist>
                                        </div>
										
									</div>`,
						data() {
							return {
                                selectedRole: 0,
                                roleFields: {
                                    text: 'Text',
                                    value: 'Value',
                                },
							}
						},
                        computed: {
                            selectedEntity() {
                                let entity = this.$store.state.selectedEntities.find((se) => se.EntityID === this.data.EntityID);

                                if (entity) {
                                    return entity;
                                }

                                return {
                                    EntityID: -1,
                                    EntityName: '',
                                    RoleID: -1
                                }
                            }
                        },
					})
				}
			},
        };
    },
    computed: {
        lblTitle() {
            return this.modalData.mode === 'edit'
                ? `Edit ${this.modalData.dto.FirstName} ${this.modalData.dto.LastName}`
                : `Add ${this.modalData.dto.UserType.Text} User`;
        },
        userTypes() {
            return this.$store.state.PermissionsModule.userTypes;
        },
        modalWidth() {
            return this.dto.UserType.Value === this.userTypes.SuperAdmin ? '400px' : '550px';
        },
        modalHeight() {
            return this.dto.UserType.Value === this.userTypes.SuperAdmin ? 'auto' : '650px';
        }
    },
    methods: {
        clearSearchText() {
            this.entitiesFilterText = '';
        },
        btnSaveOnClick() {
            if (this.dto.UserType.Value !== this.userTypes.SuperAdmin) {
                this.dto.EntityRoles = this.$store.state.selectedEntities.map((sre) => {
                    return {
                        EntityID: sre.EntityID,
                        RoleID: sre.RoleID,
                    }
                });
            } else {
                this.dto.EntityRoles = [{
                    EntityID: -1,
                    RoleID: 1
                }]
            }

            if (this.modalData.mode === 'add') {
                usersEndpoints.create(this.dto)
                .then(() => {
                    this.successClose(this.dto);
                });
            } else if (this.modalData.mode === 'edit') {
                usersEndpoints.update(this.dto)
                	.then(() => {
                		this.successClose(this.dto)
                	})
            }
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        mapEntities(arr) {
            return arr.map((a) => {
                return {
                    EntityID: a.Value,
                    EntityName: a.Text,
                    RoleID: -1
                }
            })
        },
        tabSelecting(args) {
            if (args.isSwiped) {
                args.cancel = true;
            }
        },
    },
    created() {
        this.dto = DMUtils.copy(this.modalData.dto);

        if (this.modalData.mode === 'add') {
            this.dto.IsActive = true;
        }

        if (this.dto.UserType.Value === this.userTypes.ProgramOfficer) {
            this.entitiesForUserType = this.mapEntities(this.$store.state.programOptions);
        } else if (this.dto.UserType.Value === this.userTypes.Intermediary) {
            this.entitiesForUserType = this.mapEntities(this.$store.state.intermediaryOptions);
        } else if (this.dto.UserType.Value === this.userTypes.System) {
            this.entitiesForUserType = this.mapEntities(this.$store.state.systemOptions);
        } else if (this.dto.UserType.Value === this.userTypes.State) {
            this.entitiesForUserType = this.mapEntities(this.$store.state.stateOptions);
        } else if (this.dto.UserType.Value === this.userTypes.Institution) {
            this.entitiesForUserType = this.mapEntities(this.$store.state.institutionOptions);
        }

        this.$store.commit('setSelectedEntities', this.dto.EntityRoles);

        if (this.dto.UserType.Value !== this.userTypes.SuperAdmin) {
            usersEndpoints.getRoleOptions(this.dto.UserType.Value)
                .then((response) => {
                    this.$store.commit('setRoleOptions', response)
                })
        }
    },
};
</script>
